var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-info-card',{attrs:{"title":"Features"}},_vm._l((_vm.features),function(feature){return _c('a',{key:feature,staticClass:"mb-8 grey--text body-1 d-block text-none",attrs:{"text":feature,"href":"#"},domProps:{"innerHTML":_vm._s(`&rsaquo; ${feature}`)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }